import { Component, OnInit } from "@angular/core";
import { PersonalInformationForm } from "./personal-information-form";
import { ProfileService } from "../shared/profile.service";
import { Profile } from "../shared/profile";

@Component({
  selector: "app-personal-information",
  templateUrl: "./personal-information.component.html",
  styleUrls: ["../shared/profile.scss", "./personal-information.component.scss"]
})
export class PersonalInformationComponent implements OnInit {
  form: PersonalInformationForm;
  profile: Profile;
  constructor(private profileService: ProfileService) {}

  ngOnInit() {
    this.profileService.getProfileOfCurrentUser().subscribe(profile => {
      this.profile = profile;
      this.form = new PersonalInformationForm(profile);
    });
  }

  private changeSuccess() {}

  private changeFailed(error: any) {
    switch (error.status) {
      case 401: {
        this.form.setErrors({ unauthorized: true });
      }
      //maybe others
    }
  }

  private prepareRequest(): Profile {
    return {
      email: this.form.get("email").value as string,
      phone: this.form.get("phone").value as string
    };
  }

  public submit() {
    if (false ||this.form.valid) {    //disabled function
      this.profileService
        .patchProfile(this.prepareRequest())
        .subscribe(
          profile => this.changeSuccess(),
          error => this.changeFailed(error)
        );
    } else {
    }
  }
}
